export default "__VITE_ASSET__C79$rFpJ__"